<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
  export default {
    name: 'AppMain',
    computed: {}
  }
</script>
<style>
  .app-main {
    padding: 18px 18px 0 18px;
    height: calc(100% - 18px);
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue